import { rolesList_template as VendorRolesList_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/rolesList_template";
import { renderKoDataTable, renderKoEmptyState } from "~/components/templates/listPageDataTable";
import { html, LpButton, LpPageHeader, LpTable, raw } from "~/design-system";
export class rolesList_template extends VendorRolesList_template {
    getTemplateHtml() {
        return /* html */ `
            ${LpPageHeader({
            title: "Role List",
            description: "Manage user roles and permission groups.",
            icon: "shield-check",
            actions: html `
                    <!-- ko if: isAddButtonVisible -->
                            ${LpButton({
                label: "Add role",
                prefixIcon: "plus",
                size: "base",
                variant: "primary",
                attributes: {
                    "data-bind": "click: onClickAdd",
                },
            })}
                    <!-- /ko -->
                `,
        })}

            <div class="list-page-module">
                <div class="data-module__body list-page-module__body" id="list-results">
                    ${this.getRolesTableHtml()}
                </div>
                <div class="data-module__footer list-page-module__footer">
                    <div class="list-page-module__toolbar">
                        <div class="list-page-module__meta">
                            ${this.resultInfos.getHtmlBuild()}
                        </div>
                        <div class="list-page-module__pagination">
                            ${this.pagination.getHtmlBuild()}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
    getRolesTableHtml() {
        const columns = this.getRoleTableColumns();
        return renderKoDataTable({
            title: "Roles",
            titleIcon: "shield-check",
            caption: "Role list",
            columns,
            actions: html `<div class="list-page-module__search">${raw(this.filter.getHtmlBuild())}</div>`,
            className: "roles-list-table",
            children: this.getRolesTableBodyHtml(columns),
        });
    }
    getRoleTableColumns() {
        return [
            {
                key: "id",
                label: "Id",
                sortable: true,
                resizable: true,
                width: 96,
                minWidth: 80,
                sortAttributes: this.getSortAttributes("id"),
            },
            {
                key: "name",
                label: "Name",
                sortable: true,
                resizable: true,
                minWidth: 180,
                sortAttributes: this.getSortAttributes("name"),
            },
            {
                key: "description",
                label: "Description",
                sortable: true,
                resizable: true,
                minWidth: 240,
                sortAttributes: this.getSortAttributes("description"),
            },
            {
                key: "sequence",
                label: "Sequence",
                sortable: true,
                resizable: true,
                width: 132,
                minWidth: 112,
                sortAttributes: this.getSortAttributes("sequence"),
            },
        ];
    }
    getSortAttributes(column) {
        return {
            "data-bind": `click: onClickReorder.bind($data, '${column}'), css: { 'is-desc': orderByAndDirection()=='${column}_DESC', 'is-asc': orderByAndDirection()=='${column}_ASC' }`,
        };
    }
    getRolesTableBodyHtml(columns) {
        return html `
            <input data-bind="value: orderBy" type="hidden">
            <input data-bind="value: orderByDirection" type="hidden">
            ${LpTable.Body({
            attributes: {
                "data-bind": "foreach: roles",
            },
            children: LpTable.Row({
                className: "cursor",
                children: html `
                        ${this.getRoleTextCell(columns[0], "id", "role_id")}
                        ${this.getRoleTextCell(columns[1], "name", "role_name")}
                        ${this.getRoleTextCell(columns[2], "description", "role_description")}
                        ${this.getRoleTextCell(columns[3], "sequence", "role_sequence")}
                    `,
            }),
        })}
            ${renderKoEmptyState({
            colSpan: columns.length,
            visibleBinding: "roles().length === 0",
            title: "No roles found",
            description: "No roles match the current filters.",
            icon: "shield-check",
        })}
        `;
    }
    getRoleTextCell(column, binding, className) {
        return LpTable.Cell({
            column,
            className,
            attributes: {
                "data-bind": "click: $parent.onClickView",
            },
            children: html `<span class="lp-table_cell-content" data-bind="text: ${binding}"></span>`,
        });
    }
    initPartial() {
        super.initPartial();
        this.filter.setPlaceholder("Search");
    }
}
